import React from "react";
import styles from "./styles.module.scss";

const MessageBox = ({ type = "info", message }) => {
  if (!message) return null;

  const messageClass =
    type === "error"
      ? styles.error
      : type === "success"
      ? styles.success
      : type === "important"
      ? styles.important
      : styles.info;

  return (
    <div
      className={`${styles.messageBox} ${messageClass}`}
      dangerouslySetInnerHTML={{ __html: message }}
    ></div>
  );
};

export default MessageBox;
